export default __webpack_public_path__ + "static/media/dashboard-profile-password.efa73da5.svg";